import { Button, TextField, Container, styled } from "@mui/material";

export const StyledContainer = styled(Container)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: "18px 40px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  background: "rgba(255, 255, 255, 0.1)",
  maxWidth: "800px",
  marginTop: "25px",
  border: "none",
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#06214B",
  padding: 0,
  borderRadius: "20px",
  color: "#fff",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#06214B",
  },
}));
export const ChooseFileButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#fff",
  color: "#7894f7",
  borderColor: "#7894f7",
  "&.MuiButton-root": {
    padding: "4px 8px",
    fontSize: "12px",
    minHeight: "30px",
    lineHeight: "1.5",
  },
  "@media (min-width: 320px) and (max-width: 335px)": {
    marginLeft: "-14px",
  },
}));

export const FileNameButton = styled(Button)(({ selectedFile }) => ({
  backgroundColor: "transparent",
  color: "#063af8ba",
  // fontWeight: "bold",
  pointerEvents: "none",
  border: "none",
  maxWidth: "180px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textAlign: "center",
  textOverflow: "ellipsis",
  display: "inline-block",
  direction: "ltr",
  boxShadow: "none",
  "&.MuiButton-root": {
    padding: "0",
    fontSize: "12px",
    minHeight: "auto",
    lineHeight: "1.5",
  },
}));

export const StyledTextField = styled(TextField)(({ theme, size }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: "4px",
    width: size === "xtraSmall" ? "200px" : undefined,
    height: size === "xtraSmall" ? "43px" : undefined,
    "@media (min-width: 320px) and (max-width: 400px)": {
      width: size === "xtraSmall" ? "160px" : undefined,
    },
    ...(size === "small" && {
      height: "50px",
    }),
    ...(size === "medium" && {
      height: "58px",
    }),
    ...(size === "large" && {
      height: "66px",
    }),
    padding:
      size === "extraLarge"
        ? "30px 10px"
        : size === "semiExtraLarge"
        ? "20px 10px"
        : size === "large"
        ? "30px 10px"
        : size === "medium"
        ? "10px 12px"
        : size === "semiMedium"
        ? "6px 12px"
        : size === "selectMedium"
        ? "14px 18px"
        : "10px 10px",

    "& input": {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      color: "rgb(68, 68, 69)",
      height: "10px",
      border: "none",
      outline: "none",
    },
    "& fieldset": {
      padding: 10,
      borderRadius: "10px",
      border: "2px solid #D8DEE6",
    },
    "&:hover fieldset": {
      border: "2px solid #D8DEE6",
    },
    "&.Mui-focused fieldset": {
      border: "2px solid #D8DEE6",
    },
  },
  "& label": {
    fontSize: size === "large" ? theme.typography.pxToRem(16) : "14px",
    lineHeight: "1.6rem",
    letterSpacing: "0.02rem",
    color: "#000000ce",
  },
  "& label.Mui-focused": {
    color: "#333",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ccc",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-focused": {
    borderColor: "#333",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-error": {
    borderColor: "#F44336",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-disabled": {
    borderColor: "#ccc",
  },
  "&.Mui-error": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F44336",
    },
    "& label": {
      color: "#F44336",
    },
  },
  "&.Mui-disabled": {
    "& input": {
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#2F4CDD",
  color: "#fff",
  fontWeight: "bold",
  "&:hover": {
    // backgroundColor: theme.palette.primary.dark,
  },
}));
export const styles = {
  title: {
    fontSize: "24px",
    marginTop: "30px",
    marginBottom: "30px",
    color: "#3E4954",
    fontWeight: "bold",
  },
  titles: {
    fontSize: "24px",
    marginTop: "10px",
    marginBottom: "30px",
    color: "#3E4954",
    fontWeight: "bold",
  },
  image: {
    borderRadius: "4px",
    marginRight: "10px",
  },
  photoHeading: {
    color: "grey",
    marginLeft: "5px",
  },
  photoContent: {
    fontSize: "12.8px",
    pointerEvents: "none",
    border: "none",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "normal",
    textAlign: "center",
    textOverflow: "ellipsis",
    display: "inline-block",
    direction: "ltr",
    boxShadow: "none",
    wordBreak: "break-word",
    "@media (min-width: 1200px) and (max-width: 1300px)": {
      marginLeft: "20px",
    },
  },
  note: {
    marginTop: "10px",
    fontSize: "12px",
    maxWidth: "100%",
    pointerEvents: "none",
    border: "none",
    maxWidth: "350px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textAlign: "center",
    textOverflow: "ellipsis",
    display: "inline-block",
    direction: "ltr",
    boxShadow: "none",
    "@media (min-width: 310px) and (max-width: 350px)": {
      fontSize: "10.8px",
    },
  },

  fileBoxContainer: {
    marginTop: "100px",
  },
  fileButtonContainer: {
    display: "flex",
    justifyContent: "space-around",
    padding: 2,
    gap: 0.6,
    fontSize: "16px",
  },

  saveButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: "16px",
    "@media (min-width: 320px) and (max-width: 400px)": {
      justifyContent: "center",
    },
  },
  textFieldContainer: {
    mt: 3,
    mb: 1,
    color: "#788088",
  },
  salesTextFieldContainer: {
    mt: 3,
    mb: 1,
    color: "#000",
  },
  submitGap: {
    mt: 4,
    mb: 3,
  },
  submitLoading: {
    color: "white",
    backgroundColor: "#06214b",
  },
  reactScroll: {
    height: "80vh",
  },
  reactScrollStyle: {
    width: "100%",
    height: "auto",
  },
  capacityWarning: { color: "#fa0001", fontWeight: "bold" },
  imageUploadClosePosition: { position: "relative", display: "inline-block" },
  imageUploadCloseContain: { borderRadius: "8px", objectFit: "cover" },
  imageUploadClose: {
    position: "absolute",
    top: 0,
    right: 0,
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "30%",
    width: "15px",
    height: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  addBackButtonDisplay: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginTop: "12px",
  },
  addBackButtonColor: {
    backgroundColor: "#4c67ee",
    color: "#fff",
    marginTop: "20px",
  },
};

//Permission Styles
export const containerStyles = {
  padding: { xs: "20px", md: "40px" },
  marginTop: "-42px",
};

export const tableContainerStyles = {
  borderRadius: "8px",
  overflowX: "auto",
  overflowY: "hidden",
};

export const tableStyles = {
  borderCollapse: "separate",
  borderSpacing: "0",
  height: "100%",
};

export const tableCellHeaderStyles = {
  fontWeight: "bold",
  textAlign: "center",
  border: "none",
};

export const tableCellBodyStyles = (index, rowIndex, rolesLength) => ({
  borderRight: index === 2 ? "4px solid #cad1f5" : "none",
  borderBottom: rowIndex === rolesLength - 1 ? "4px solid #cad1f5" : "none",
  borderTop: rowIndex === 0 ? "4px solid #cad1f5" : "none",
});

export const tableRowLabelCellStyles = {
  textAlign: "center",
  border: "none",
  borderRight: "4px solid #cad1f5",
  fontWeight: "bold",
};

export const iconStyle = {
  fontSize: "40px",
};

export const stackStyles = {
  paddingTop: "50px",
  margin: 1,
};

export const paperStyles = {
  padding: "8px",
  backgroundColor: "#2f4cdd",
  color: "#fff",
  borderRadius: "16px",
};

export const typographyBody1Styles = {
  fontWeight: "bold",
};
